export default {
  verified: {
    id: 'product_page_verified',
    defaultMessage: 'Verified refurbished',
  },
}
